import {FormikSelect} from "../form/FormikSelect";
import React, {FC} from "react";

export const FormikSalutationSelect: FC<{prefix?: string}> = ({prefix}) => {
    console.log(prefix ? prefix + ".salutation" : "salutation");
    return (
    <FormikSelect
        fullWidth
        name={prefix ? prefix + ".salutation" : "salutation"}
        label="Anrede"
        required
        options={[
            {value: 'Herr', label: 'Herr'},
            {value: 'Frau', label: 'Frau'},
            {value: 'Divers', label: 'Divers'},
        ]}
    />
)};
